var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.333 100H175L100 25L25 100H41.6667V158.333C41.6667 162.754 43.4226 166.993 46.5482 170.118C49.6738 173.244 53.9131 175 58.3333 175H104.167M75 175V125C75 120.58 76.7559 116.34 79.8816 113.215C83.0072 110.089 87.2464 108.333 91.6667 108.333H108.333C112.754 108.333 116.993 110.089 120.118 113.215C123.244 116.34 125 120.58 125 125M133.333 158.333H183.333M158.333 133.333V183.333",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaps);
export default __webpack_public_path__ + "static/media/CAPS.211c91818159166e2de121e72f5f125d.svg";
export { ForwardRef as ReactComponent };